import React, { useState } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import Layout from '../components/Layout';
import ProjectCard from '../components/ProjectCard';
import ProjectDetail from '../components/ProjectDetail';
import { projectsData } from '../data/projectsData';
import heroBg from '../assets/andwil/6.jpg';

export const Services = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectDetailOpen, setProjectDetailOpen] = useState(false);

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setProjectDetailOpen(true);
  };

  const handleCloseProjectDetail = () => {
    setProjectDetailOpen(false);
    setSelectedProject(null);
  };

  return (
    <Layout>
      {/* Hero Section */}
      <Box
        sx={{
          minHeight: '50vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#1a1a1a',
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center 200%',
          backgroundAttachment: 'fixed',
          position: 'relative'
        }}>
        <Container maxWidth='lg'>
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <Typography
              variant='h1'
              sx={{
                color: '#fff',
                fontWeight: 700,
                fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4.5rem' },
                fontFamily: 'Jura, sans-serif',
                letterSpacing: '0.02em',
                textAlign: 'center',
                mb: 3
              }}>
              Referenzen
            </Typography>
            <Typography
              variant='h5'
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                maxWidth: '800px',
                mx: 'auto',
                textAlign: 'center',
                fontFamily: 'Jura, sans-serif',
                fontWeight: 400,
                fontSize: { xs: '1rem', md: '1.2rem' },
                lineHeight: 1.6
              }}>
              Entdecken Sie unsere realisierten Projekte aus der Schweiz
            </Typography>
          </motion.div>
        </Container>
      </Box>

      {/* Projects Grid */}
      <Box sx={{ backgroundColor: '#fff', py: { xs: 8, md: 12 } }}>
        <Container maxWidth={false} disableGutters sx={{ px: { xs: 2, sm: 3, lg: 6 }, width: '100%', maxWidth: '1800px', mx: 'auto' }}>
          <Box
            sx={{
              display: 'grid',
              gap: { xs: 1.5, sm: 2.5, md: 3 },
              gridTemplateColumns: {
                xs: 'repeat(1, minmax(0, 1fr))',
                sm: 'repeat(2, minmax(0, 1fr))',
                md: 'repeat(3, minmax(0, 1fr))',
                lg: 'repeat(4, minmax(0, 1fr))'
              },
              justifyItems: 'center',
              justifyContent: 'center',
              maxWidth: { xs: 360, sm: 'none' },
              width: '100%',
              mx: { xs: 'auto', sm: 0 },
              alignItems: 'stretch'
            }}>
            {projectsData.map((project) => (
              <Box key={project.id} sx={{ width: '100%' }}>
                <ProjectCard project={project} onClick={handleProjectClick} />
              </Box>
            ))}
          </Box>
        </Container>
      </Box>

      {/* Project Detail Dialog */}
      <ProjectDetail project={selectedProject} open={projectDetailOpen} onClose={handleCloseProjectDetail} />
    </Layout>
  );
};
